(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ApiDocContentModResp', '../model/ModMetadataResp', '../model/CpContentMetadata', '../model/Nothing', '../model/ContentCreationResp'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ApiDocContentModResp'), require('../model/ModMetadataResp'), require('../model/CpContentMetadata'), require('../model/Nothing'), require('../model/ContentCreationResp'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VcpApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.ApiDocContentModResp, root.SmartCsV2Sdk.ModMetadataResp, root.SmartCsV2Sdk.CpContentMetadata, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.ContentCreationResp);
  }
}(this, function(ApiClient, ApiDocContentModResp, ModMetadataResp, CpContentMetadata, Nothing, ContentCreationResp) {
  'use strict';

  /**
   * Vcp service.
   * @module api/VcpApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VcpApi. 
   * @alias module:api/VcpApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getModInfo operation.
     * @callback module:api/VcpApi~getModInfoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ApiDocContentModResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Content Mod info
     * &lt;p&gt;\n Retrieve the current user&#39;s moderated content portal contents
     * @param {module:model/String} status 
     * @param {Object} opts Optional parameters
     * @param {String} opts.nextPage 
     * @param {module:api/VcpApi~getModInfoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ApiDocContentModResp}
     */
    this.getModInfo = function(status, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'status' is set
      if (status == undefined || status == null) {
        throw "Missing the required parameter 'status' when calling getModInfo";
      }


      var pathParams = {
      };
      var queryParams = {
        'status': status,
        'nextPage': opts['nextPage']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ApiDocContentModResp;

      return this.apiClient.callApi(
        '/v2/cp/mod', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getModMetadata operation.
     * @callback module:api/VcpApi~getModMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ModMetadataResp} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Content Mod Metadata for a user
     * &lt;p&gt;\n Retrieve the moderation metadata for current user
     * @param {module:api/VcpApi~getModMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ModMetadataResp}
     */
    this.getModMetadata = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ModMetadataResp;

      return this.apiClient.callApi(
        '/v2/cp/mod/metadata', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the initCpMetadata operation.
     * @callback module:api/VcpApi~initCpMetadataCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * POST new Metadata to a uploaded CP content.
     * &lt;p&gt;\n This API only works for CP Content has no mod status yet, i.e. Pre-metadata status
     * @param {String} contentId 
     * @param {module:model/CpContentMetadata} metadata 
     * @param {module:api/VcpApi~initCpMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.initCpMetadata = function(contentId, metadata, callback) {
      var postBody = metadata;

      // verify the required parameter 'contentId' is set
      if (contentId == undefined || contentId == null) {
        throw "Missing the required parameter 'contentId' when calling initCpMetadata";
      }

      // verify the required parameter 'metadata' is set
      if (metadata == undefined || metadata == null) {
        throw "Missing the required parameter 'metadata' when calling initCpMetadata";
      }


      var pathParams = {
        'contentId': contentId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/cp/{contentId}/metadata', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadNewResource operation.
     * @callback module:api/VcpApi~uploadNewResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a new resource via Content portal
     * &lt;p&gt;\n This API expects a file and an optional metadata (see model definition).&lt;/br&gt;\n If no metadata presents, the content will not be visible through mod APIs and will expire in 2 days&lt;/br&gt;\n If the metadata is present, if the metadata is invalid, 400 will be returned; otherwise\n the content will be automatically put into PENDING mod status.
     * @param {File} fileStream 
     * @param {Object} opts Optional parameters
     * @param {String} opts.params 
     * @param {module:api/VcpApi~uploadNewResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.uploadNewResource = function(fileStream, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling uploadNewResource";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'params': opts['params']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/cp/upload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
